import React, { useEffect, useState } from 'react';
import styles from './ModalForm.module.css';
import { useTranslation } from 'react-i18next';

import { Button, TextInput } from '@mantine/core';
import { useForm } from '@mantine/form';
import { linkValidator } from '@utils/validators';

const Form = ({ createClaim, onClose }) => {
  const { t } = useTranslation();
  const form = useForm({
    validateInputOnBlur: true,
    initialValues: {
      placeName: '',
      googleLink: ''
    },

    validate: {
      placeName: (value) => (value?.length > 0 ? null : t('empty.invalid')),
      googleLink: (value) => linkValidator(value, t),
    },
  });

  useEffect(() => {
    window.gtag('event', 'open_adding_place_card')
  }, [])

  const handleSubmit = async (values) => {
    const data = await createClaim(values);

    if (data?.errors?.length > 0) {
      data?.errors.forEach(error => {
        switch (error.code) {
          case 'P202':
            form.setErrors({
              claim: t('claim.limit.error')
            })

            break;

          case 'P050':
            form.setErrors({
              claim: t('notifications.permissionError')
            })

            break;

          default:
            break;
        }
      })
    } else {
      window.gtag('event', 'action_application_sent')

      onClose();
    }
  }

  const handleBlurName = () => {
    const value = form.getValues().placeName;
    const placeName = value.replace(/^(\s|\u00A0)+|(\s|\u00A0)+$/g, "")

    form.setValues({
      placeName
    })

    const error = form.validateField('placeName')

    if (error) {
      form.setErrors({ placeName: error.error });
    }
  }

  const handleBlur = () => {
    const value = form.getValues().googleLink;
    const googleLink = value.replace(/^(\s|\u00A0)+|(\s|\u00A0)+$/g, "")

    form.setValues({
      googleLink
    })

    const error = form.validateField('googleLink')

    if (error) {
      form.setErrors({ googleLink: error.error });
    }
  }

  return (
    <div className={styles.wrapper}>
      <form
        className={styles.form}
        onSubmit={form.onSubmit(handleSubmit)}
      >
        <div className={styles.separator} />

        <TextInput
          label={t('placeName.label')}
          placeholder={t('placeName.placeholder')}
          key={form.key('placeName')}
          {...form.getInputProps('placeName')}
          onBlur={handleBlurName}
        />

        <div className={styles.separator} />

        <TextInput
          label={t('placeHref.label')}
          placeholder={t('placeHref.placeholder')}
          key={form.key('googleLink')}
          error={form.errors?.googleLink}
          {...form.getInputProps('googleLink')}
          onBlur={handleBlur}
        />

        {!form.errors.googleLink && (
          <div className={styles.description}>
            {t('map.input.description')}
          </div>)}

        {form.errors?.claim && (
          <div className={styles.claim}>
            {form.errors.claim}
          </div>
        )}

        <Button
          className={styles.button}
          fullWidth
          type="submit"
          disabled={!form.getValues().placeName || !form.getValues().googleLink || form.errors.googleLink}
        >
          {t('confirm')}
        </Button>
      </form>
    </div >
  )
}

export default Form;
